import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IMasterList } from "../../../Pages/Master/IMaster";

export const AddMasterSlicer = createSlice({
  name: "AddMaster",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IMasterList>,
  reducers: {
    addMaster: (state, _) => {
      state.isLoading = true;
    },
    successAddMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddMaster: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddMasterState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addMaster,
  failureAddMaster,
  successAddMaster,
  clearAddMasterState,
} = AddMasterSlicer.actions;

export default AddMasterSlicer.reducer;
